var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "139px",
    height: "83px",
    viewBox: "0 0 139 83",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,83 C15.3569531,82.735034 6,73.4348217 6,62 C6,50.5651783 15.3569531,41.264966 27.0002271,41.005562 L27,41 L27.490771,41.0004016 C30.3074032,23.973924 44.9096337,11 62.5,11 C68.0487268,11 73.3001246,12.2909465 77.9780639,14.592821 C82.747267,8.73251391 89.9459701,5 98,5 C112.359403,5 124,16.8644541 124,31.5 C124,35.0305854 123.322591,38.3999108 122.09302,41.4803212 C131.760235,43.5350219 139,51.9417042 139,62 C139,73.5979797 129.374122,83 117.5,83 C117.332957,83 117.166359,82.9981393 117.000227,82.994438 L117,83 L27,83 Z",
    id: "Combined-Shape",
    fill: "#00ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,78 C9.35695308,77.735034 0,68.4348217 0,57 C0,45.5651783 9.35695308,36.264966 21.0002271,36.005562 L21,36 L21.490771,36.0004016 C24.3074032,18.973924 38.9096337,6 56.5,6 C62.0487268,6 67.3001246,7.29094655 71.9780639,9.59282101 C76.747267,3.73251391 83.9459701,0 92,0 C106.359403,0 118,11.8644541 118,26.5 C118,30.0305854 117.322591,33.3999108 116.09302,36.4803212 C125.760235,38.5350219 133,46.9417042 133,57 C133,68.5979797 123.374122,78 111.5,78 C111.332957,78 111.166359,77.9981393 111.000227,77.994438 L111,78 L21,78 Z",
    id: "Combined-Shape-Copy",
    fill: "#02D9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,78 C33.3741221,78 97.5439453,78 105.908203,78 C87.3554688,35 40.0527344,78 21.5,35 C9.62587788,35 4.97379915e-14,44.6258779 4.97379915e-14,56.5 C4.97379915e-14,68.3741221 9.62587788,78 21.5,78 Z",
    id: "Oval",
    fill: "#00CCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,20 C71.209139,20 73,21.790861 73,24 L72.9998403,51 L80.3040997,51 C82.5132387,51 84.3040997,52.790861 84.3040997,55 C84.3040997,56.1577588 83.8024657,57.2587254 82.9288146,58.0184221 L70.6247149,68.7176393 C69.1196287,70.0264098 66.8803713,70.0264098 65.3752851,68.7176393 L53.0711854,58.0184221 C51.4041569,56.5688321 51.2278882,54.0423136 52.6774782,52.3752851 C53.4371748,51.501634 54.5381415,51 55.6959003,51 L62.9998403,51 L63,24 C63,21.790861 64.790861,20 67,20 L69,20 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.f2053e16a7cf914da0c98db0ee3b9769.svg";
export { ForwardRef as ReactComponent };